module.exports = __webpack_public_path__ + "static/media/F Pop up 6.8ffca7a8.png";